module.exports = __webpack_public_path__ + "img/forecast_map.0323b672.png";